// Brand loader — the Arbox loader.gif served from public/. No CSS spinners.
// See docs/platform/05-arbox-ui-design-system.md §9.

interface LoaderProps {
  size?: number;
  fullScreen?: boolean;
  alt?: string;
}

export function Loader({ size = 64, fullScreen = false, alt = 'טוען…' }: LoaderProps) {
  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-grey-bg">
        <img src="/loader.gif" alt={alt} width={size} height={size} />
      </div>
    );
  }
  return <img src="/loader.gif" alt={alt} width={size} height={size} />;
}

/**
 * Indicator for antd Spin / ProTable's loading prop.
 *
 *   loading={isFetching ? { spinning: true, indicator: loaderIndicator() } : false}
 *
 * Without this, the table falls back to antd's CSS spinner — visually
 * inconsistent with the rest of the app.
 */
export function loaderIndicator(size: 'sm' | 'md' | 'lg' = 'md') {
  const px = size === 'sm' ? 24 : size === 'lg' ? 64 : 36;
  return <img src="/loader.gif" alt="" width={px} height={px} />;
}
